import type { ReactNode } from 'react';

type Props = {
  variant?: 'phone' | 'desktop';
  children: ReactNode;
  className?: string;
};

/** Phone or desktop device frame, CSS-only. */
export function DeviceFrame({ variant = 'phone', children, className }: Props) {
  if (variant === 'desktop') {
    return (
      <div className={`ow-mockup ${className ?? ''}`}>
        <div
          className="bg-bg-elevated border border-border-strong overflow-hidden"
          style={{ borderRadius: 16, boxShadow: 'var(--ow-shadow-lg)' }}
        >
          {/* tab bar */}
          <div className="flex items-center gap-1.5 px-4 py-3 border-b border-border bg-bg-subtle">
            <span className="w-2.5 h-2.5 rounded-full bg-border-strong" />
            <span className="w-2.5 h-2.5 rounded-full bg-border-strong" />
            <span className="w-2.5 h-2.5 rounded-full bg-border-strong" />
            <span className="ml-3 text-[10px] font-display text-muted tracking-wider">
              orthodoxway.app
            </span>
          </div>
          <div className="aspect-16/10">{children}</div>
        </div>
      </div>
    );
  }
  return (
    <div
      className={`ow-mockup bg-bg-elevated overflow-hidden ${className ?? ''}`}
      style={{
        borderRadius: 32,
        width: 280,
        boxShadow: 'var(--ow-shadow-lg), 0 0 0 6px #0F1A2B, 0 0 0 8px var(--ow-border-strong)',
        aspectRatio: '9 / 20',
      }}
    >
      <div className="h-full flex flex-col relative">
        {/* Dynamic-island notch */}
        <div
          aria-hidden
          className="absolute left-1/2 -translate-x-1/2 z-10 rounded-full"
          style={{
            top: 8,
            width: 80,
            height: 18,
            background: '#0F1A2B',
          }}
        />
        <div className="flex-1 overflow-hidden">{children}</div>
      </div>
    </div>
  );
}
